import { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import ProfileCard from "./ProfileCard";

const ProfileContactSection = ({ form, setForm, updateProfileSection }) => {
  const [editing, setEditing] = useState(false);

  const saveContact = async () => {
    await updateProfileSection({
      phone: form.phone,
      linkedin: form.linkedin,
      address: form.address,
    });

    setEditing(false);
  };

  return (
    <ProfileCard
      title="Contact"
      isEditing={editing}
      onEdit={() => setEditing(true)}
      onSave={saveContact}
      onCancel={() => setEditing(false)}
    >
      {!editing ? (
        <>
          <p>
            <strong>Email:</strong> {form.email}
          </p>
          <p>
            <strong>LinkedIn:</strong> {form.linkedin || "Not added"}
          </p>
          <p>
            <strong>Phone:</strong> {form.phone || "Not added"}
          </p>
          <p>
            <strong>Address:</strong>{" "}
            {form.address.street ||
            form.address.city ||
            form.address.state ||
            form.address.zip ||
            form.address.country
              ? `${form.address.street || ""}${
                  form.address.city ? ", " + form.address.city : ""
                }${form.address.state ? ", " + form.address.state : ""}${
                  form.address.zip ? ", " + form.address.zip : ""
                }${form.address.country ? ", " + form.address.country : ""}`
              : "Not added"}
          </p>
        </>
      ) : (
        <>
          {/* EMAIL (disabled) */}
          <Form.Control className="mb-3" value={form.email} disabled />

          {/* LINKEDIN */}
          <Form.Control
            className="mb-3"
            placeholder="LinkedIn URL"
            value={form.linkedin}
            onChange={(e) =>
              setForm((p) => ({ ...p, linkedin: e.target.value }))
            }
          />

          {/* PHONE */}
          <Form.Control
            className="mb-3"
            placeholder="Phone"
            value={form.phone}
            onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))}
          />

          {/* STREET (full width) */}
          <Form.Control
            className="mb-3"
            placeholder="Street"
            value={form.address.street || ""}
            onChange={(e) =>
              setForm((p) => ({
                ...p,
                address: { ...p.address, street: e.target.value },
              }))
            }
          />

          {/* CITY + STATE */}
          <Row>
            <Col>
              <Form.Control
                className="mb-3"
                placeholder="City"
                value={form.address.city || ""}
                onChange={(e) =>
                  setForm((p) => ({
                    ...p,
                    address: { ...p.address, city: e.target.value },
                  }))
                }
              />
            </Col>
            <Col>
              <Form.Control
                className="mb-3"
                placeholder="State"
                value={form.address.state || ""}
                onChange={(e) =>
                  setForm((p) => ({
                    ...p,
                    address: { ...p.address, state: e.target.value },
                  }))
                }
              />
            </Col>
          </Row>

          {/* ZIP + COUNTRY */}
          <Row>
            <Col>
              <Form.Control
                className="mb-2"
                placeholder="ZIP Code"
                value={form.address.zip || ""}
                onChange={(e) =>
                  setForm((p) => ({
                    ...p,
                    address: { ...p.address, zip: e.target.value },
                  }))
                }
              />
            </Col>
            <Col>
              <Form.Control
                className="mb-2"
                placeholder="Country"
                value={form.address.country || ""}
                onChange={(e) =>
                  setForm((p) => ({
                    ...p,
                    address: { ...p.address, country: e.target.value },
                  }))
                }
              />
            </Col>
          </Row>
        </>
      )}
    </ProfileCard>
  );
};

export default ProfileContactSection;
